import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { ConvertToFlexiInstructionDispatcher } from "./Variable";

export interface ConvertToFlexiInstructionStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class ConvertToFlexiInstructionStatic extends BaseStore<ConvertToFlexiInstructionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ConvertToFlexiInstructionDispatcher, (actionData) => this.onConvertToFlexiInstructionStoreResponse(actionData));
    }

    public getLastResult(): ConvertToFlexiInstructionStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ConvertToFlexiInstructionStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onConvertToFlexiInstructionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                    this.setState({ actionType: actionData.actionTyped });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
